import type { ProjectDetail } from '@/stores/project/types';
import { create } from 'zustand';

interface RecentProjectStore {
  recentProjects: ProjectDetail[];
  setRecentProjects: (recentProjects: ProjectDetail[]) => void;
  upsertRecentProject: (project: ProjectDetail) => void;
  updateRecentProject: (projectId: string, updater: (project: ProjectDetail) => ProjectDetail) => void;
  updateRecentProjectTitle: (projectId: string, projectTitle: string) => void;
  removeRecentProject: (projectId: string) => void;
}

export const useRecentProjectStore = create<RecentProjectStore>(set => ({
  recentProjects: [],
  setRecentProjects: recentProjects =>
    set(state => {
      const remoteProjectIds = new Set(recentProjects.map(project => project.id));
      const localOnlyProjects = state.recentProjects.filter(project => !remoteProjectIds.has(project.id));

      return {
        recentProjects: [
          ...localOnlyProjects,
          ...recentProjects,
        ],
      };
    }),
  upsertRecentProject: project =>
    set(state => ({
      recentProjects: [
        project,
        ...state.recentProjects.filter(item => item.id !== project.id),
      ],
    })),
  updateRecentProject: (projectId, updater) =>
    set(state => ({
      recentProjects: state.recentProjects.map(project =>
        project.id === projectId ? updater(project) : project,
      ),
    })),
  updateRecentProjectTitle: (projectId, projectTitle) =>
    set(state => ({
      recentProjects: state.recentProjects.map(project =>
        project.id === projectId ? { ...project, name: projectTitle } : project,
      ),
    })),
  removeRecentProject: projectId =>
    set(state => ({
      recentProjects: state.recentProjects.filter(project => project.id !== projectId),
    })),
}));
